import { type ExternalMessageLoader, isLocaleSupported } from '@canvas/intl';
import type { SupportedLocale } from '@canvas/intl-types';

import { DatasourceMessagesMap, smartCardMessagesMap } from './external-messages';
import { pickExternalMessages } from './utils';

enum DatabasesExternalMessage {
  SMART_CARD = 'smart-card',
  DATASOURCES = 'link-datasource',
}
/**
 * Define a map of each locale and its loaders for external dependencies. We must do it this way
 * as Vite needs to know the dependencies at build time, so we cannot dynamically construct
 * the import paths
 */
export const externalMessagesMap: Record<
  SupportedLocale,
  Record<DatabasesExternalMessage, ExternalMessageLoader[]>
> = pickExternalMessages(
  {
    name: DatabasesExternalMessage.SMART_CARD,
    map: smartCardMessagesMap,
  },
  {
    name: DatabasesExternalMessage.DATASOURCES,
    map: DatasourceMessagesMap,
  }
);

export function getExternalDatabasesMessages(
  userLocale: string
): Record<DatabasesExternalMessage, ExternalMessageLoader[]> {
  const locale: SupportedLocale = isLocaleSupported(userLocale) ? userLocale : 'en';

  return externalMessagesMap[locale];
}
